const FLAGS = {
  PROFILE: {
    IS_ACTIVE_CAMPAIGN_ENABLED: 'isActiveCampaignEnabled'
  },
  LIST_POSTS: {
    IS_BULK_VIDEO_UPLOAD_ENABLED: 'isVideoBulkUploadEnabled'
  },
  CHECKOUT: {
    IS_PIX_ENABLED: 'isPixEnabled',
    IS_BANKSLIP_ENABLED: 'isBankslipEnabled',
    IS_CREDIT_CARD_ENABLED: 'isCreditCardEnabled',
    IS_PIX_UNSTABLE_MESSAGE_ENABLED: 'isPixUnstableMessageEnabled',
    USE_ASYNC_CHECKOUT: 'useAsyncCheckout',
    USE_WORKSPACE_CHECKOUT_GREEN: 'useWorkspaceCheckoutGreen',
    /**
     * Enables the new creator UI, that allow creators to use upsell in
     * their strategy.
     */
    IS_UPSELL_CREATOR_UI_ENABLED: 'isUpsellCreatorUIEnabled',
    IS_MAGIC_LINK_GROUP_ENABLED: 'isMagicLinkCreatorEnabled',
    IS_REDIRECT_CHECKOUT_GROUP_TO_PAY: 'isRedirectCheckoutGroupToPay',
    CHECKOUT_MULTIGATEWAY_FALLBACK_SETTINGS: 'checkoutMultigatewayFallbackSettings'
  },
  USER_SUBSCRIPTION_MODAL: {
    IS_CHANGE_PLAN_ENABLED: 'isChangePlanEnabled'
  },
  JOIN_GROUP: {
    IS_TELEGRAM_BLOCKED: 'isTelegramBlocked'
  },
  BILLING: {
    IS_V2_ENABLED: 'isBillingV2Enabled'
  },
  /**
   * When the user logs in and access the creator mode, they go to this area.
   *
   * Example (in devel environment): https://app.hubla.dev/dashboard#products
   */
  DASHBOARD: {
    IS_REPORTS_ENABLED: 'isReportsEnabled',
    IS_CLIENTS_ENABLED: 'isClientsEnabled',
    IS_HOME_V2_ENABLED: 'isDashboardHomeV2Enabled',
    /**
     * Enables order bump, allowing creators to enable this option in their
     * dashboard. Details in go/order-bump-figma.
     */
    IS_ORDER_BUMP_ENABLED: 'isOrderBumpEnabled',
    /**
     * Enable the use of product filtering in both the charts and the listing
     * of invoices within the creator's dashboard.
     */
    IS_FILTER_BY_PRODUCT_ENABLED: 'isFilterByProductEnabled'
  },
  CREATE_PRODUCT: {
    IS_PRODUCT_COHORT_ENABLED: 'isProductCohortEnabled'
  },
  MODULE_HIGHLIGHT: {
    IS_MODULE_HIGHLIGHT_ENABLED: 'isModuleHighlightEnabled'
  },
  LIST_SECTIONS: {
    IS_NEW_LIST_SECTIONS_ENABLED: 'isNewListSectionsEnabled'
  }
};

export { FLAGS };
